import {Component, computed, inject} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Button} from "primeng/button";
import {MenuItem} from "primeng/api";
import {Breadcrumb} from "primeng/breadcrumb";
import {Splitter} from "primeng/splitter";
import {DashboardStore} from "@widgets/dashboard";
import {
    AddElementDrawerComponent,
    NodeSelectComponent,
    SettingsComponent,
    WidgetConstructorStore,
    WidgetGridComponent
} from "@widgets/widget-constructor";
import {DatasetStore} from "@entities/widget-element";
import {DashboardMapperService} from "../../lib/dashboard.mapper.service";

@Component({
    selector: "dashboard-widget-constructor",
    imports: [
        Button,
        Breadcrumb,
        AddElementDrawerComponent,
        NodeSelectComponent,
        WidgetGridComponent,
        SettingsComponent,
        Splitter,
    ],
    templateUrl: "./widget-constructor-page.component.html",
    styleUrl: "./widget-constructor-page.component.scss"
})
export class WidgetConstructorPageComponent {
    readonly router = inject(Router);
    readonly route = inject(ActivatedRoute);
    readonly dbStore = inject(DashboardStore);
    readonly constructorStore = inject(WidgetConstructorStore);
    readonly datasetStore = inject(DatasetStore);
    readonly mapper = inject(DashboardMapperService);

    readonly widget = computed(() => this.constructorStore.editingWidget()!);

    breadcrumbItems: MenuItem[] = [
        {label: "Панель мониторинга", routerLink: "../../"},
        {label: "Конструктор виджетов"},
    ];
    home: MenuItem = {routerLink: "../../"};

    updateExistingWidget() {
        const widget = this.mapper.mapEditingWidgetToWidget(this.widget());

        this.dbStore.updateWidgetWithEditingWidget(widget);
        this.router.navigate(["../../"], {relativeTo: this.route});
    }

    createNewWidget() {
        const widget = this.mapper.mapEditingWidgetToNewWidget(this.widget(), this.dbStore.lastCreatedId());

        this.dbStore.addNewWidget(widget);
        this.router.navigate(["../../"], {relativeTo: this.route});
    }

    dropChanges() {
        this.loadElementsDatasets();
        this.router.navigate(["../../"], {relativeTo: this.route});
    }

    private loadElementsDatasets() {
        const widget = this.dbStore.widgets().find(widget => widget.id === this.widget().id);
        widget?.data.elements.forEach(element => {
            element.data.content.datasets.forEach(dataset => {
                this.datasetStore.loadDataset({
                    elementId: element.id,
                    datasetId: dataset.id,
                    elementType: element.data.content.elementType,
                    datasetType: element.data.metadata.datasetType,
                    temporalCount: element.data.metadata.temporalCount,
                    precision: element.data.metadata.precision
                });
            });
        });
    }
}
